import React from "react";
import {Participant} from "../../Types/ParticipantTypes";
import {Col, Row} from "reactstrap";
import WidgetInformationWithIcon from "../../../../CommonComponents/Dashboard/DashboardWidget";
import {Award, Layout, TrendingUp, DollarSign} from "react-feather";

interface participantDashboardProps {
    participant: Participant
}

const ParticipantDashboard = ({participant}: participantDashboardProps) => {

    return (
        <div>
            <Row>
                <Col xxl='auto' xl='3' sm='6' className='box-col-6'>
                    <Row>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Boards',
                                gros: 5,
                                total: participant.statistics?.boards?.length ?? 0,
                                color: 'primary',
                                icon: <Layout size={16} color={'orange'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Winning Numbers',
                                gros: 50,
                                total: participant.statistics?.winningNumbers ?? 0,
                                color: 'secondary',
                                icon: <Award size={16} color={'purple'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Numbers',
                                gros: 20,
                                total: participant.statistics?.numbers ?? 0,
                                color: 'success',
                                icon: <TrendingUp size={16} color={'green'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Points',
                                gros: 10,
                                total: participant.statistics?.points ?? 0,
                                color: 'default',
                                icon: <DollarSign size={16} color={'blue'}/>,
                            }}/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default ParticipantDashboard;





